import { leadActivityService } from '../../helpers/services/leadActivity.service'
import { sharedHelper } from '@/utils'

export const state = {
  list: [],
  today: [],
  overdue: [],
  upcoming: [],
  calendar: [],
  status: { list: true, save: true },
}

export const LEAD_ACTIVITY_MODULE = 'leadActivity'

export const GET_LEAD_ACTIVITIES = 'getLeadActivities'
export const CREATE_LEAD_ACTIVITY = 'createLeadActivity'
export const UPDATE_LEAD_ACTIVITY = 'updateLeadActivity'
export const DELETE_LEAD_ACTIVITY = 'deleteLeadActivity'
export const COMPLETE_LEAD_ACTIVITY = 'completeLeadActivity'
export const GET_TODAY_ACTIVITIES = 'getTodayActivities'
export const GET_OVERDUE_ACTIVITIES = 'getOverdueActivities'
export const GET_UPCOMING_ACTIVITIES = 'getUpcomingActivities'
export const GET_CALENDAR_ACTIVITIES = 'getCalendarActivities'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const LIST_SUCCESS = 'listSuccess'
const DASH_SUCCESS = 'dashSuccess'

export const actions = {
  [GET_LEAD_ACTIVITIES]({ commit }, { filter } = {}) {
    commit(REQUESTING, 'list')
    return leadActivityService.getAll(filter || {}).then((r) => {
      commit(LIST_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [CREATE_LEAD_ACTIVITY]({ commit }, { payload }) {
    commit(REQUESTING, 'save')
    return leadActivityService.create(payload).then((r) => {
      commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE); return null
    })
  },
  [UPDATE_LEAD_ACTIVITY]({ commit }, { uuid, payload }) {
    commit(REQUESTING, 'save')
    return leadActivityService.update(uuid, payload).then((r) => {
      commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE); return null
    })
  },
  [DELETE_LEAD_ACTIVITY]({ commit }, { uuid }) {
    commit(REQUESTING, 'save')
    return leadActivityService.remove(uuid).then(() => {
      commit(SUCCESS); return true
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE); return false
    })
  },
  [COMPLETE_LEAD_ACTIVITY]({ commit }, { uuid }) {
    commit(REQUESTING, 'save')
    return leadActivityService.complete(uuid).then((r) => {
      commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE); return null
    })
  },
  [GET_TODAY_ACTIVITIES]({ commit }) {
    return leadActivityService.getToday().then((r) => {
      commit(DASH_SUCCESS, { key: 'today', data: r }); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
  [GET_OVERDUE_ACTIVITIES]({ commit }) {
    return leadActivityService.getOverdue().then((r) => {
      commit(DASH_SUCCESS, { key: 'overdue', data: r }); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
  [GET_UPCOMING_ACTIVITIES]({ commit }) {
    return leadActivityService.getUpcoming().then((r) => {
      commit(DASH_SUCCESS, { key: 'upcoming', data: r }); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
  [GET_CALENDAR_ACTIVITIES]({ commit }, { dateFrom, dateTo }) {
    return leadActivityService.getCalendar(dateFrom, dateTo).then((r) => {
      commit(DASH_SUCCESS, { key: 'calendar', data: r }); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
}

export const mutations = {
  [LIST_SUCCESS](state, data) {
    state.list = data?.data || []
  },
  [DASH_SUCCESS](state, { key, data }) {
    state[key] = data?.data || []
  },
  [FAILURE](state) { state.status = { list: true, save: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { list: true, save: true } },
}
